/**
 * 15 minutes in seconds - default value on the API
 */
export const SESSION_DURATION_DEFAULT = 15 * 60;
/**
 * 2 mins in seconds
 */
export const SESSION_DURATION_ALERT_OFFSET = 2 * 60;
/**
 * localStorage key
 */
export const SESSION_DURATION_LOCALSTORAGE_SYNC_KEY = 'cb:session-duration-sync-counter';
